import React from 'react';
import PropTypes from 'prop-types';
import styles from './TransferableSelectItem.scss';
import ItemPropType from './ItemPropType.js';

class TransferableSelectItemTemplate extends React.Component {
  render() {
    let {
      item,
      className
    } = this.props;

    let renderedData = <div>{item.data}</div>;

    if (item.component) {
      const RenderComponent = item.component;
      renderedData = <RenderComponent data={item.data} />;
    }
    else if (item.render) {
      renderedData = item.render(item.data);
    }
    return (
      <div className={`${styles.item} ${className}`}>
        <div className={`${styles.icon} ${item.isPending ? styles.pending : ''}`}>
          <div className={styles.grippy}></div>
          <div className={styles.grippy}></div>
          <div className={styles.grippy}></div>
        </div>
        <div className={styles.data}>
          {renderedData}
        </div>
      </div>
    );
  }
}

TransferableSelectItemTemplate.propTypes = {
  item: ItemPropType.isRequired,
  className: PropTypes.string
};

export default TransferableSelectItemTemplate;